import React, { Fragment, useEffect, useState } from "react";
import { APP_DOMAIN } from "../../constants/constants";
import { useResume } from "../../context/ResumeContext";
import ErrorBox from "./ErrorBox";
import { ActionButton } from "./ActionButton";
import { usePopup } from "../../context/PopupContext";
import ErrorBoxMobile from "./ErrorBoxMobile";
export const LeftSection = (props) => {
    const [sectionErrors, setSectionErrors] = useState({});
    const [noSectionErrors, setNoSectionErrors] = useState()
    const [showButtonErrors, setShowButtonErrors] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [mobileDevice, setMobileDevice] = useState('');
    const { close } = usePopup();
    //This is work around for Suggestion boxes not able to retain its open close state when resume object refreshed
    const [suggestionBoxes, setSuggestionBoxes] = useState({})
    const noerror = {}
    const {
        resume,
        handlers,
        filterIgnoredSuggestions,
        ignoreIt,
        scanReviewSuggestions,
        getFieldSuggestionId
    } = useResume();
    useEffect(() => {
        const errors = scanReviewSuggestions(props.section?.id, props.section?.openedRowId && props.section?.openedRowId(resume[props.section?.id]))
        deleteOldUnlinkedError(errors)
        errors && setSectionErrors(errors)
        setNoSectionErrors(Object.keys(scanReviewSuggestions(props.section?.id, null, true)).length == 0)
        // resume_review[props.section?.id].errors
        // console.log('asdfasdf,',errors)
    }, [resume]);
    useEffect(() => {
        window.scrollTo(0, 0)
        setTimeout(() => window.pageYOffset && window.scrollTo(0, 0), 500)
        //First time
        setMobileDevice(window.innerWidth > 769 ? false : true);
        //every second time
        function handleResize() {
            setMobileDevice(window.innerWidth > 769 ? false : true);
        }
        window.addEventListener('resize', handleResize);
        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    const toggleErrors = () => {
        setShowButtonErrors(prevState => !prevState);
    };

    const scrollToErrorField = (element_id) => {
        setShowButtonErrors(prevState => !prevState);
        const targetDiv = document.getElementById(element_id);
        if (targetDiv) {
            const top = targetDiv.getBoundingClientRect().top - 60;
            const scrollToPosition = top > 0 ? window.pageYOffset + top : 0;
            window.scrollTo({top: scrollToPosition,behavior: 'smooth'});
        }
    }
    //Function will handle to remove unlined entries so open/close state will not retain when same error surface again.
    //Its edge case but has to do it
    const deleteOldUnlinkedError = (errors) => {
        const _tstate = {}
        Object.keys(suggestionBoxes).length && Object.keys(errors)?.map((key, k1) => {
            const row = errors[key]
            Object.keys(row).map((rule_key, k) => {
                const suggestion_id = getFieldSuggestionId(props.section.id, key, row[rule_key]?.parent_key) + rule_key;
                suggestionBoxes.hasOwnProperty(suggestion_id) && (_tstate[suggestion_id] = suggestionBoxes[suggestion_id])
            })
        })
        setSuggestionBoxes({..._tstate})
    }

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    const ListSuggestions = () => {
        return Object.keys(sectionErrors).length ?
            <div className="err-container">{Object.keys(sectionErrors).map((key, k1) => {
                const row = sectionErrors[key], s = []//['description', 'content'];
                // console.log(sectionErrors, key)
                //spell mistakes will be handled separately in header itself
                const errors = Object.keys(row).filter((key) => key != '');//spelling_mistakes
                const sectionErrorsCount = Object.keys(sectionErrors).length;
                if (errors.length) {
                    return errors.map((rule_key, k) => {
                        const element_id = getFieldSuggestionId(props.section.id, key, row[rule_key]?.parent_key);
                        const suggestion_id = element_id + rule_key
                        return (
                            mobileDevice ?
                                <ErrorBoxMobile element_id={element_id} message={row[rule_key].message} description={row[rule_key].description} key={k + k1} ignoreSuggestion={() => {ignoreIt(props.section?.id, row[rule_key]); 
                                    //"Handle case for Ignore the last suggestion, forcefully close the popup. Otherwise it popup again as soon as any suggestion introduced"
                                    sectionErrorsCount === 1 && toggleErrors()
                                    }} toggleErrors={toggleErrors} scrollToErrorField={() => scrollToErrorField(element_id)} />
                                :
                                <ErrorBox 
                                    message={row[rule_key].message} 
                                    description={row[rule_key].description} 
                                    key={k + k1} 
                                    ignoreSuggestion={() => ignoreIt(props.section?.id, row[rule_key])} 
                                    openit={suggestionBoxes?.[suggestion_id] ?? (k + k1 === 0)}
                                    onClick= {() => {
                                        setSuggestionBoxes({...suggestionBoxes, [suggestion_id] : !suggestionBoxes?.[suggestion_id] })
                                    } }
                                />)
                    })
                }
            }
            )}</div> : //No error cases
            ['work_history', 'education_history'].includes(props.section.id) &&
            (props.section?.openedRowId(resume[props.section?.id]) ? //One section is opened
                (!noSectionErrors && //Has some errors
                    <div className="err-container">
                        <ErrorBox
                            message={'Looking good!'}
                            description={`Click "View Suggestions" to review options for Professional Experience.`}
                            key={2343}
                            success="success"
                            hide_ignore_button={true}
                            openit = {true}
                            />
                    </div>) ://Case of all 
                (
                    (!noSectionErrors && //Has some errors
                        <div className="err-container">
                            <ErrorBox
                                message={'Review suggestions'}
                                description={`Click "View Suggestions" to see options.`}
                                key={2343}
                                // success="success"
                                hide_ignore_button={true}
                                openit = {true}
                                />
                        </div>
                    )
                )

            )
    }
    return (
        <>
            {!noSectionErrors && mobileDevice && <div className="btn-container">
                <div className='show-error-btn hide-in-desktop' onClick={() => toggleErrors()} id="show-err-box">
                    <span>Show Errors</span>
                    <img src={`${APP_DOMAIN}/assets/images/${showButtonErrors ? 'up-angle' : 'down-angle'}.svg`} />
                </div>

            </div>}<ActionButton />
            {!mobileDevice && <ListSuggestions />

            }

            {!noSectionErrors && mobileDevice && showButtonErrors && (<div className="err-container hide-in-desktop">
                <div className="transparent-popup-bg"></div>
                <div className="err-pop-container custom-skip-popup">
                    <div className="content-box">
                        <ListSuggestions />
                    </div>
                    <div className="err-close-footer close-btn-icon" onClick={toggleErrors}>
                        <span>Close</span>
                        {/* <button className="close-icon"
                       >Close</button> */}
                    </div>
                </div>
            </div>)}
            {!mobileDevice && noSectionErrors && <div className="err-container"><ErrorBox message={'Well done! This section is looking great.'} description={"Move to another section"} key={2343} success="success" hide_ignore_button={true} disableDescription={true} /> </div>}


        </>
    )
}